<template>
    <div id="contendor-principal-correccionConResultado">
        <div id="contenedor-encabezados-correccionCOnResultado" class="text-left">
            <h1>CORRECCIÓN DE CÉDULA CON RESULTADO</h1>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div v-if="!esCorreccion && cedulaEncontrada" class="flex-grow-1"><button type="button" @click="limpiarFormulario" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
            <div v-if="!esCorreccion && cedulaEncontrada" class="flex-grow-1" style="padding-left: 11em;"><h4>Consulta y creacion de correcciones</h4></div>
            <div v-if="!esCorreccion && cedulaEncontrada" class="flex-grow-1"></div>
            <div v-if="esCorreccion" class="flex-grow-1 pl-3"><h4>Búsqueda de cédula</h4></div>
        </div>
        <div id="contenedor-correccion" class="col-12 area">
             <!-- <h3>Sigue los pasos para realizar correcciones a una cedula</h3> -->
             <div v-if="esCorreccion" class="d-flex justify-content-between mt-2">
                <div id="filtros-coreeccionCedula-sr" style="width: 65%">
                    <FiltrosDeBusqueda class="contenedor-color-negro"
                        :catalogos="filtrosDeBusqueda" 
                        :ejecutaLaFuncion="evtBuscarCedula" 
                        :filtrosEstablecidos="filtrosEstablecidos"
                        :tituloDeBusqueda="'Paso 1: Busque la cédula con ayuda de los filtros'"
                        :ref="REF_FILTROS_BUSQUEDA"
                        :key="'FBVCCCR' + contRender"></FiltrosDeBusqueda>
                </div>
                <div class="contenedor-color-negro d-flex align-items-center justify-content-center" style="width: 33%">
                    <div>
                        <div id="icono-estatus-busqueda" class="d-flex justify-content-center">
                            <i v-if="busquedaCedula" class="fas fa-archive"></i>
                            <i v-if="!busquedaCedula" class="fas fa-file-alt"></i>
                        </div>
                        <div id="estatus-busqueda-cedula">
                            <div class="d-flex justify-content-center align-items-center">
                                <h4 v-if="busquedaCedula"><i class="fas fa-search"></i> Buscar cedula</h4>
                                <h4 v-if="cedulaEncontrada">Cédula encontrada: <i class="fas fa-check-circle text-success"></i></h4>
                                <h4 v-if="!cedulaEncontrada && !busquedaCedula">Cédula incorrecta <i class="fas fa-times-circle text-danger"></i></h4>
                            </div>
                            <div v-if="!cedulaEncontrada && !busquedaCedula" class="d-flex justify-content-center">
                                <i>{{ mensajeCedulaNoEncontrada }}</i>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
            <div v-if="!esCorreccion && cedulaEncontrada" id="contenedor-cancelacion-cedula" class="d-flex justify-content-between mt-2">
                <CDescripcionBasicaDeCedula class="contenedor-color-negro" style="width: 45%"
                        :idDelInput="'descripcionCedulaVCCCR'"
                        :cedula="cedulaBD"></CDescripcionBasicaDeCedula>
                 <div style="width: 53%;">
                     <div class="contenedor-color-negro">
                        <h5>Paso 2: Descarga el documento y sube las correcciones</h5>
                        <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                        <div class="form-group">
                            <div class="form-group">
                                <h6 for="ultima-factaulizacion">Fecha de ultima actualizacion.</h6>
                                <input disabled="disabled" v-model="ultimaFechaActualizacion" type="text" id="ultima-factaulizacion" class="form-control"/>
                            </div>
                            <div class="form-group">
                                <h6 :for="'input-archivo'">Documento actual de la cédula</h6>
                                <div class="contenedor-documento" :id="'input-archivo'">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                                            <span style="color: #000000; font-weight: bold;">{{ nombreArchivoDeCedula }}</span>
                                        </div>
                                    <div v-if="campoRequeridoEsValido(cedulaBD.ArchivoRuta)">
                                        <button @click="descargarPlantillaBD" type="button" class="btn-sm btn-primary"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Descargar</button>
                                        <button @click="evtVisualizarDocumento()" type="button" class="btn-sm btn-primary"><i class="fas fa-eye"></i>&nbsp;&nbsp;Ver</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mt-4">
                                <h6 for="input-archivo-conCorreccion-vcccr">Seleccione el archivo (
                                    <i v-for="(tipoDoc, index) in extensionesDocumento" :key="index">.{{tipoDoc}} <i v-if="index < extensionesDocumento.length - 1">, </i></i>) a subir&nbsp;
                                    <i v-if="mostrarErrores && this.campoRequeridoEsValido(archivoConCorrecciones)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="mostrarErrores && !this.campoRequeridoEsValido(archivoConCorrecciones)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                    <button v-if="this.campoRequeridoEsValido(archivoConCorrecciones)" @click="evtVisualizarDocumentoCorrecciones()" type="button" class="btn-sm btn-primary"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Revisar</button></h6>
                                <input type="file" id="input-archivo-conCorreccion-vcccr" :class="[mostrarErrores && !this.campoRequeridoEsValido(archivoConCorrecciones) ? 'form-control border border-danger' : 'form-control']" v-on:change="evtAgregarDocumentoConCorrecciones($event)" accept=".DOC, .DOCX" />
                                <div v-if="this.campoRequeridoEsValido(archivoConCorrecciones)" class="form-inline mt-1">
                                    <i>Resvisa el documento antes de guardar.</i>
                                </div>
                                <div class="d-flex justify-content-end" style="margin-top: 2em;">
                                    <button @click="evtGuardarCorrecciones" type="button" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar Correcciones</button>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
             </div>
             <div :class="[esCorreccion ? 'd-flex justify-content-end mt-4' : 'd-flex mt-4']">
                <button v-if="esCorreccion && cedulaEncontrada" type="button" class="btn btn-primary" @click="irCorregir">Ir a realizar correcciones&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                <!-- <button v-if="!esCorreccion && cedulaEncontrada" type="button" class="btn btn-primary" @click="limpiarFormulario"><i class="fas fa-arrow-circle-left"></i>&nbsp;&nbsp;Regresar</button> -->
            </div>
         </div>
         <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false" id="eleccion-cedula-VCCCR">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <!-- <i class="fas fa-info-circle"></i>&nbsp;Se -->
                        <h5 class="modal-title">EN LA BÚSQUEDA SE OBTUVIERON VARIAS CÉDULAS</h5>
                        <button id="'btn-cerrar-eleccion-cedula-VCCCR" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 25px 30px 25px 30px;">
                        <div v-if="cedulasEncontradasTabla.length > 0" class="contenedor-color-negro">
                            <h5><i class="fas fa-info-circle"></i>&nbsp;Selecciona una cédula</h5>
                            <TablaGenericaCedulas class="table-responsive"
                                :idDelInput="'T-cedulas-VCCCR'" 
                                :encabezadosColumnas="encabezadosColumnas" 
                                :accionesEnTabla="tablaAcciones" 
                                :listaDeCedulas="cedulasEncontradasTabla"
                                :conResponsive="true"
                                v-on:accionesFuncionElegir="evtEleccionDeCedula"></TablaGenericaCedulas>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
         <!-- Modal para visor de seleccion de archivo actual -->
         <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documento-vccr-ac">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento actual de la cedula</h5>
                        <button id="btn-cerrar-visor-documento-vccr-ac" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="this.campoRequeridoEsValido(cedulaBD)">
                                <PDFDocument 
                                    :url="cedulaBD.ArchivoRuta"
                                    :height="'600px'" 
                                    :key="'KVPDVAC' + contRenderVPDF"/>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
        <!-- Modal para visor de seleccion de subidor -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documento-vccr-su">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento con correcciones</h5>
                        <button id="btn-cerrar-visor-documento-vccr-su" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="this.campoRequeridoEsValido(archivoConCorrecciones)">
                                <PDFDocument 
                                    :url="''" 
                                    :ArchivoAConvertir="archivoConCorrecciones" 
                                    :height="'600px'" 
                                    :key="'KVPFACCR' + contRenderVPDFAC"/>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import PDFDocument from '@/../src/components/Comunes/PDFDocument'

export default {
    components: {
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CDescripcionBasicaDeCedula: sistemas.SINOJ.CDescripcionBasicaDeCedula,
        PDFDocument,
        CSubidorDeArchivos: sistemas.SINOJ.CSubidorDeArchivos,
        TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            REF_FILTROS_BUSQUEDA: 'REFFBVCCCR',
            filtrosDeBusqueda: [
                { 
                    catalogoId: 'filtroNumeroFolio',
                    idDelInput: 'INFVCSR'
                },
                { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'f-tMateria-VCDCR' },
                { 
                    catalogoId: enumeraciones.catalogos.Consecutivo, 
                    idDelInput: 'INCVCSR' 
                }, 
                { 
                    catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'INJZCSR'
                },
                { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'f-tDocumento-VCCCR' },
                { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-VCCCR' }
            ],
            filtrosEstablecidos: {},
            contRender: 0,
            busquedaCedula: true,
            cedulaEncontrada: false,
            esCorreccion: true,
            cedulaBD: null,
            nombreArchivoDeCedula: null,
            ultimaFechaActualizacion: null,
            FORMATO_FECHA: "DD-MM-YYYY",
            contRenderVPDF: 0,
            mostrarErrores: false,
            extensionesDocumento: ['doc, docx'],
            archivoConCorrecciones: null,
            contRenderVPDFAC: 0,
            encabezadosColumnas: ['Folio','Fecha de registro', 'Tipo de cédula','Estatus', 'Resultado', ''],
            tablaAcciones: { motrarAcciones: true, check: false, eliminar: false, detalles: false, ver: false, elegir: true},
            cedulasEncontradasTabla: [],
            cedulasEncontradasBD: [],
            mensajeCedulaNoEncontrada: 'No se encontró cédula',
            cargoAreaDeUsuario: false
        }
    },
    methods: {
        prb: function() {
            //console.log('areaDeUsuario::', this.areaDeUsuario);
        },
        evtEleccionDeCedula: function(evento) {
            this.cedulaBD = null;
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.cedulasEncontradasBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
                this.cedulaBD = c;
                this.asignarValoresEnFiltros();
            });
        },
        asignarValoresEnFiltros: function() {
            this.contRenderVPDF ++;
            this.obtenerNombreDeArchivoCedula();
            this.obtenerUltimaFechaDeAcutualizacion();
            this.busquedaCedula = false;
            this.cedulaEncontrada = true;
            this.esCorreccion = true;
            this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio = this.cedulaBD.CedulaId;
             // valores de expediente
            if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
                let { Materia, Consecutivo, TipoDocumento, Juzgado, NumeroDeDocumento } = this.cedulaBD.Expediente;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = Juzgado.JuzgadoId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId = Materia.MateriaId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId = TipoDocumento.TipoDocumentoId;
                if(TipoDocumento.TipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || TipoDocumento.TipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente) {
                    this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra = Consecutivo;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].mostrarNumeroExtra = true;
                }
                this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo = NumeroDeDocumento; 

                // se renderizan los catalogos
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.key = 'CFMTVCD' + this.contRender;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZVCD' + this.contRender;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.key = 'CFTDVCD' + this.contRender;
            }
            $('#eleccion-cedula-VCCCR').modal('hide');
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtGuardarCorrecciones: function() {
            if(this.campoRequeridoEsValido(this.archivoConCorrecciones)) {
                this.mostrarErrores = false;
                this.guardarCorreccionesBD();
            }
            else {
                this.mostrarErrores = true;
                comun.mensajeDeAlerta('Se detectaron campos incorrectos,<br>No se encuentran ningun archivo seleccionado.');
            }
        },
        creaPeticionGuardarCorrecciones: function() {
            let peticion = new FormData();
            peticion.append('EsPrueba',false);
            const CEDULA = { CedulaId: this.cedulaBD.CedulaId, FechaDeRegistro: this.cedulaBD.FechaDeRegistro, Urgente: this.cedulaBD.Urgente };
            peticion.append('Cedula',JSON.stringify(CEDULA));
            peticion.append('ArchivoCorrecciones',this.archivoConCorrecciones);
            return peticion;
        },
        guardarCorreccionesBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.cedulas.correccionConResultado.CorreccionACedulaConResultado;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = true;
            let peticionAPI = this.creaPeticionGuardarCorrecciones();
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            if(respuesta.data.Cedula != null) {
                                this.cedulaBD = respuesta.data.Cedula;
                                this.obtenerNombreDeArchivoCedula();
                                this.obtenerUltimaFechaDeAcutualizacion();
                                this.contRenderVPDF ++;
                                comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtAgregarDocumentoConCorrecciones: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoConCorrecciones = evento.target.files[0];
                    this.contRenderVPDFAC ++;
                    $('#visor-documento-vccr-su').modal('show');
                }
                else {
                    this.archivoConCorrecciones = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtVisualizarDocumentoCorrecciones: function() {
            $('#visor-documento-vccr-su').modal('show');
        },
        evtVisualizarDocumento: function() {
            $('#visor-documento-vccr-ac').modal('show');
        },
        descargarPlantillaBD: function() { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.cedulaBD.ArchivoRuta}`
            a.click();
        },
        buscarCedulaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.cedulas.correccionConResultado.ObtenerCedulaParaCorreccionCR;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let peticionAPI = {
                CedulaId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio) ? this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio : null,
                MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId : null,
                TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId : null,
                Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra)) ? parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra) : null,
                NumeroExpediente: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo) ? this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo : null,
                JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId : null,
                esPrueba: false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.cedulasEncontradasBD = respuesta.data.Cedulas;
                            this.cedulasEncontradasTabla = [];
                            if(this.cedulasEncontradasBD != null && this.cedulasEncontradasBD.length > 0) {
                                this.evaluarBusquedaCedula();
                            }
                            else {
                                this.mensajeCedulaNoEncontrada = 'No se encontró cedula';
                                this.busquedaCedula = false;
                                this.cedulaEncontrada = false;
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evaluarBusquedaCedula: function() { 
            if(this.cedulasEncontradasBD.length == 1) { 
                this.cedulaBD = this.cedulasEncontradasBD[0];
                if(this.cedulaBD.Resultado == null) {
                    this.mensajeCedulaNoEncontrada = 'La cédula buscada no tiene resultado'
                    this.busquedaCedula = false;
                }
                else {
                    this.contRenderVPDF ++;
                    this.obtenerNombreDeArchivoCedula();
                    this.obtenerUltimaFechaDeAcutualizacion();
                    this.busquedaCedula = false;
                    this.cedulaEncontrada = true;
                    this.esCorreccion = true;
                }
            }
            else {
                this.cedulasEncontradasTabla = this.darFormatoCedulasTabla(this.cedulasEncontradasBD.filter(c => c.Resultado != null));
                if(this.campoRequeridoEsValido(this.cedulasEncontradasTabla) && this.cedulasEncontradasTabla.length < 1) {
                    $('#eleccion-cedula-VCCCR').modal('hide');
                    this.mensajeCedulaNoEncontrada = 'las cedulas encontradas no tienen resultado'
                    this.busquedaCedula = false;
                }
                else {
                    $('#eleccion-cedula-VCCCR').modal('show');
                }
            }
        },
        /**
         * Metodo encargado de dar formato a objetos de cedula al formato
         * [Folio,Fecha de creacion, Tipo de cedula] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) {
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.FechaDeRegistro = moment(cedula.FechaDeRegistro).format(this.FORMATO_FECHA);
            cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
            cedulaObjTabla.Estatus = cedula.Estatus.Nombre; 
            cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
            return cedulaObjTabla;
        },
        obtenerUltimaFechaDeAcutualizacion: function() {
            if(this.campoRequeridoEsValido(this.cedulaBD.FechaDeCorreccion))
                this.ultimaFechaActualizacion = moment(this.cedulaBD.FechaDeCorreccion).format(this.FORMATO_FECHA);
            else
                this.ultimaFechaActualizacion = moment(this.cedulaBD.FechaDeRegistro).format(this.FORMATO_FECHA);
        },
        obtenerNombreDeArchivoCedula: function() {
            if(this.campoRequeridoEsValido(this.cedulaBD.ArchivoRuta)) {
                const RUTA_ARCHIVO = this.cedulaBD.ArchivoRuta.split('\\');
                const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
                this.nombreArchivoDeCedula =` ${NOMBRE_ARCHIVO}`;
            }
            else {
                this.nombreArchivoDeCedula = 'Sin documento.'
            }
        },
        evtBuscarCedula: function(evento) {
            this.nombreArchivoDeCedula = null;
            this.busquedaCedula = true;
            this.cedulaEncontrada = false;
            this.buscarCedulaBD();
        },
        irCorregir: function() {
            this.esCorreccion = false;
        },
        limpiarFormulario: function() {
            this.mostrarErrores = false;
            this.cedulaBD = null;
            this.archivoConCorrecciones = null;
            $("#input-archivo-conCorreccion-vcccr").val('');
            this.busquedaCedula = true;
            this.cedulaEncontrada = false;
            this.esCorreccion = true;
            this.$nextTick(() => {
                this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
            });
            this.contRender ++;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        asignarValoresDeUsuario: function(areaDeUsuario) {
             // se asignan los valores del usuario (en mounted y no en created porque es hasta que este creada la instancia del componente FiltrosDeBusqueda)
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.esInformativo = this.campoRequeridoEsValido(AreaId) ? true : false;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = this.campoRequeridoEsValido() ? AreaId : -1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZVCD' + this.contRender;
                const VALOR_EVENTO = {
                    target: { value: this.campoRequeridoEsValido(AreaId) ? AreaId : -1 }
                };
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                this.$refs[this.REF_FILTROS_BUSQUEDA].cambioDeArea(VALOR_EVENTO);
            }
        }
    },
    mounted() { 
        $(window).resize(() => {
            this.contRenderVPDF ++;
            this.contRenderVPDFAC ++;
        });
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
        }
    },
    watch: {
        '$store.state.Login_Usuario.Area': function() {
            this.$nextTick(() => {
                if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) { 
                    this.cargoAreaDeUsuario = true;
                    this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
                }
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1100px) {
  #icono-estatus-busqueda i{
    font-size: 14em !important;
  }
}

@media only screen and (max-width: 900px) {
    #icono-estatus-busqueda i{
        font-size: 10em !important;
    }

    #estatus-busqueda-cedula h4 {
        font-size: 5px !important;
    }
}

@media only screen and (max-width: 1290px) {

    #estatus-busqueda-cedula h4 {
        font-size: 18px !important;
    }

    #estatus-busqueda-cedula {
        width: 250px !important;
    }
}

.btn-sm {
    cursor: pointer;
    padding: 4px 8px 4px 8px;
    background-color: #555558;
}

.btn-sm:hover {
    background-color: black;
}

.contenedor-documento {
    padding: 8px 12px 8px 12px;
    border-radius: 4px;
    background-color: #817c7c;
}

#visor-documento-vccr-su .modal-lg, #visor-documento-vccr-ac .modal-lg {
    max-width: 70% !important;
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#icono-estatus-busqueda i{
    font-size: 19em;
    margin-bottom: 20px;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}
    
#estatus-busqueda-cedula {
    background-color: #1e2020;
    width: 25em;
    padding: 1em;
    border-radius: 8px;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/ManejoDeCedulas/CorreccionConResultado/CCorreccionCedulaConResultado.vue